import { faBuildingColumns } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getMainNavOrg: () => NavRoute = () => {
	return {
		name: "Organizations"
        , security: security => security.manageOrgUsers
		, path: 'organizations/list'
        , icon: faBuildingColumns
        , area: 'organizations'
		, expanded: globalThis.location.href.includes("/organizations/")
		, children: [
			{
				name: 'By Event'
				, exact: true
				, path: 'organizations/list'
                , activeNavLink: 'organizations/list'
		        , secondaryNav: ['Organizations', 'By Event']
			}
		]
	};
};
